
<app-common-search-view [form]="form" header="Närvaro på institutionsnivå/år" (createReport)="createReport($event)" [showSpinner]="showSpinner" (clearReportView)="clearReport()"></app-common-search-view>


<br>
<div *ngIf="result?.length > 0" class="col-md-12">
  <p-menubar [model]="items">
    <div style="margin-top:5px;margin-right:10px;">
      Resultat: {{result?.length}}
  </div>
  </p-menubar>
  <table *ngIf="result?.length > 0" class="table table-border">
    <tr>
      <th>Insttyp</th>
      <th>Nr</th>
      <th>Namn</th>
      <th>Distrikt</th>
      <th>Mötestyp</th>
      <th>År</th>
      <th>Antal möten</th>
      <th>Antal egnas besök i annans inst.</th>
      <th>Antal gäster från annan inst.</th>
      <th>Egna närvarande</th>
      <th>Antal medlemmar i logen vid årets slut</th>
    </tr>
    <tr *ngFor="let r of result">
      <td>{{r.institutionType}}</td>
      <td>{{r.nr}}</td>
      <td>{{r.name}}</td>
      <td>{{r.district}}</td>
      <td>{{r.meetingType}}</td>
      <td>{{r.year}}</td>
      <td>{{r.numberOfMeetings}}</td>
      <td>{{r.numberOfOwnMembersInOtherInstitutions}}</td>
      <td>{{r.numberOfGuestsFromOtherInstitutions}}</td>
      <td>{{r.attendance}}</td>
      <td>{{r.membersAtEndOfYear}}</td>
    </tr>
  </table>

</div>

  <!--<div class="col-md-1">
    <button class="btn btn-primary" style="width:30px;margin-left:4px;"
            (click)="narvaroPerManad($event)">
    </button>
  </div>

<div class="col-md-1">
  <button class="btn btn-primary" style="width:30px;margin-left:4px;"
          (click)="narvaroPerDistrikt($event)">
  </button>
</div>-->

<!--div class="col-md-1">
  <button class="btn btn-primary" style="width:30px;margin-left:4px;"
          (click)="narvaroPerMedlem($event)">
  </button>
</div-->
<br><br>


